// F5-1 五图1
import { FC } from 'react'
import clsx from 'clsx'
import { IMutipleMedia, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import PdMedia from '@/components/pd-media/pd-media'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'
import TagItem from '../../tag-item'
const FeaturedMediaGrid: FC<IMutipleMedia> = ({ title, desc, mediaGroup, theme, mediaBorderRadius = 0, paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const isMobile = useMobileDetector()

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full max-w-300 mx-auto')}>
        <TitleAndDesc title={title} desc={desc} />
        <div className={clsx('grid gap-x-3 gap-y-12', 'grid-cols-2 laptop:grid-cols-3', 'px-6 laptop:px-0')}>
          {mediaGroup?.map((item, index) => (
            <div className={clsx('relative', index === 0 ? 'col-span-2' : 'col-span-1')} key={item.title}>
              <div
                className={clsx('w-full overflow-hidden', 'h-172px laptop:h-105', 'mb-3 laptop:mb-0')}
                style={{ borderRadius: `${mediaBorderRadius}px` }}
              >
                <PdMedia
                  src={isMobile ? item.mediaH5Url || item.mediaUrl || '' : item.mediaUrl || ''}
                  mask={false}
                  className="hover:scale-110 transition-all ease-in-out duration-[800ms]"
                />
              </div>
              <div
                className={clsx(
                  'laptop:absolute laptop:top-0 laptop:left-0 laptop:inset-0 laptop:p-6 laptop:pointer-events-none'
                )}
              >
                <TagItem title={item.title} desc={item.desc} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeaturedMediaGrid
